export default __webpack_public_path__ + "static/media/CPCSEA.e79b9473.jpg";